import Notice from 'components/ui/notice'

import { IExchangeData } from 'store/fetchers/loans/enum'
import { ICurrency } from 'store/fetchers/currencies'

import { ReactElement } from 'react'
import cn from 'classnames'

import { useTranslation } from 'utils/use-translation'
import TabsSlider from 'components/ui/tabs-slider'
import AprOptions from 'components/ui/apr-options'
import useWindowWidth from 'hooks/use-window-width'

import styles from './styles.module.scss'

export default function TermsBlock({
  ltvOptions,
  ltvPercent,
  handleChangeLvtPercent,
  handleChangeAprOption,
  aprOptions,
  activeAprOption,
}: {
  exchange: IExchangeData
  to: ICurrency
  ltvOptions: string[]
  ltvPercent: string
  handleChangeLvtPercent: (value: string) => void
  handleChangeAprOption: (value: string) => void
  aprOptions: any[]
  activeAprOption: string
}): ReactElement {
  const { t } = useTranslation()
  const width = useWindowWidth()

  return (
    <section className={styles.container}>
      <div className={styles.item}>
        <div className={styles['item-name']}>
          <p>{t('ltv')}</p>
          <Notice alt={'ltv-notice'} big type="secondary">
            <span dangerouslySetInnerHTML={{ __html: t('loan_to_value_ratio_strong') }}></span>
          </Notice>
        </div>
        <div className={styles['item-options']}>
          {ltvOptions?.length > 0 && (
            <TabsSlider
              tabs={ltvOptions}
              activeTab={ltvPercent}
              handleTabChange={handleChangeLvtPercent}
              type="white"
              className={styles['ltv-options__wrapper']}
              activeTabClassName={styles['ltv-options__wrapper_active']}
            />
          )}
        </div>
      </div>

      <div className={cn(styles.item, styles.column)}>
        <div className={styles['item-name']}>
          <p>{t('choose_apr')}</p>
          <Notice alt={'choose-apr-notice'} big type="secondary">
            {aprOptions.length > 2 ? t('apr_notice_dynamic_fixed') : t('apr_notice_dynamic_fixed_2')}
          </Notice>
        </div>
        <div className={cn(styles['item-value__apr'])}>
          <AprOptions
            data={aprOptions}
            activeOption={activeAprOption}
            handleChangeOption={handleChangeAprOption}
            tabClassName={styles['apr-option']}
            isSwipable={width <= 480}
            className={styles['apr-wrapper']}
            isLk
          />
        </div>
      </div>
    </section>
  )
}
